/* eslint-disable vue/multi-word-component-names */
import VGauge from 'vgauge'
import Vue from 'vue'
Vue.component('Vgauge', VGauge)
